import { FC } from 'react'

export const Services: FC = () => {
  return <p>campaign services</p>
}
